angular.module('jv.Admin.Users')
    .controller('jvImportEmployeeController', [
        '$scope', '$rootScope','TemplateLoader','$window','$timeout',
        function($scope, $rootScope,TemplateLoader,$window,$timeout) {
            $scope.fileError = false;
            $scope.fullSyncFlagAlert = false;
            $scope.standardJobCategoryName = "";
            $scope.standardJobCategoryNames = [];
            $scope.requiredUnmappedCount = 0;
            $scope.unmappedCount = 0;
            $scope.topWarning = false;
            $scope.fieldSections = [];
            $scope.personal = {};
            $scope.jobInformation = {};
            $scope.contactInformation = {};
            $scope.organizationInformation = {};
            $scope.regionInformation = {};
            $scope.response = null;
            $scope.setting={};
            $scope.checkbox = {
                sendInviteEmail: false,
                selectAll: false,
                fullSync:false,
    			resetSync:false,
    			considerExclusionList:false
            };
            $scope.files = {
                uploadedFile:{} 
            };
            $scope.reset = function() {
                $scope.fileError = false;
                $scope.files = {
                    uploadedFile:{} 
                };
                $scope.checkbox.sendInviteEmail = false;
                $scope.checkbox.fullSync = false;
                $scope.checkbox.resetSync = false;
                $scope.checkbox.considerExclusionList = false;
                //add resetting error and actual uploaded file html
            };
            
            $scope.fieldValueSelected = function(object) {
               if(object.required && object.toAttribute && (object.toAttribute.text).trim() !== "") {
                    if($scope.requiredUnmappedCount > 0) {
                        $scope.requiredUnmappedCount--;
                    }
                    object.calculatedUnmapped = false;
                }
                if(object.required &&  object.toAttribute && (object.toAttribute.text).trim() === "" && !object.calculatedUnmapped) {
                    object.calculatedUnmapped = true;
                    $scope.requiredUnmappedCount++;
                }
                if(!object.required && object.selected && object.toAttribute && (object.toAttribute.text).trim() !== "") {
                    object.calculatedUnmapped = false;
                    if($scope.unmappedCount > 0) {
                        $scope.unmappedCount--;
                    }
                }
                if(!object.required && object.selected && object.toAttribute && (object.toAttribute.text).trim() === "" && !object.calculatedUnmapped) {
                    object.calculatedUnmapped = true;
                    $scope.unmappedCount++;
                }
                $scope.showWarning(object);
            };
            
            $scope.showWarning = function(object) {
                 if(object.selected && object.toAttribute && (object.toAttribute.text).trim() === "") {
                    object.calculatedUnmapped = true;
                    object.iconColor = "orange";
                    object.notes = "Unmapped";
                    if(object.required) {
                        object.iconColor = "red";
                        object.notes = "Required for import";
                    }
                    object.showError = true;
                } else {
                    object.showError = false;
                }
                if(!object.selected && object.calculatedUnmapped) {
                    object.calculatedUnmapped = false;
                    $scope.unmappedCount--;
                }
                if($scope.requiredUnmappedCount > 0 || $scope.unmappedCount > 0) {
                    $scope.topWarning = true;
                } else {
                    $scope.topWarning = false;
                }
            };
            
            $scope.calculateCount = function(object) {
                if(object.selected && object.toAttribute && (object.toAttribute.text).trim() === "") {
                    if(object.required) {
                        $scope.requiredCount++;
                    } else {
                        $scope.count++;
                    }
                }
            };
            
            $scope.showWarnings = function() {
                for(var section in $scope.fieldSections){
                    for(var entry in $scope.fieldSections[section].data){
                        $scope.showWarning($scope.fieldSections[section].data[entry]);
                        $scope.calculateCount($scope.fieldSections[section].data[entry]);
                    }
                }
                $scope.requiredUnmappedCount = $scope.requiredCount;
                $scope.unmappedCount = $scope.count;
                $scope.topWarning = $scope.requiredUnmappedCount > 0 || $scope.unmappedCount > 0;
            };
            
            $scope.checked = function(object) {
                if(object.selected) {
                    if(object.required && object.toAttribute && (object.toAttribute.text).trim() === "" && !object.calculatedUnmapped) {
                        $scope.requiredUnmappedCount++;
                    } else if(!object.required && object.toAttribute && (object.toAttribute.text).trim() === "" && !object.calculatedUnmapped){
                        $scope.unmappedCount++;
                    }
                } 
                $scope.topWarning = $scope.requiredUnmappedCount > 0 || $scope.unmappedCount > 0;
                $scope.showWarning(object);
                return object.selected;
            };
            var showImportEmployeeModal = $rootScope.$on('showImportEmployeeModal', function(event, data) {
                $scope.fileError = false;
                $scope.importModal = data;
                $scope.showModals('importEmployee');
                $scope.setting.delimiters=[
               	 {id:"0", text: ", (Comma)"},
               	 {id:"1", text: "\\t (Tab)"}
               ];
               $scope.setting.delimiterSelected=$scope.setting.delimiters[0];
            });
            
            var showImportEmployeeConfirmationModal = $rootScope.$on('showImportEmployeeConfirmationModal', function(event, data) {
                $scope.showModals('importEmployeeConfirmation');
            });
            
            var showImportEmployeeConfirmation = $rootScope.$on('showImportEmployeeConfirmation', function(event, data) {
                $scope.showModals('importEmployeeConfirmation');
            });

            //modal to show failure of import employees
            var showImportFailureModal = $rootScope.$on('showImportFailureModal', function(event, data) {
                 $scope.showModals('importEmployeesErrorModal');
             });

            // Modal Information
            $scope.modals = {
                importEmployee: {
                    show: false
                }, 
                importEmployeeConfirmation : {
                    show: false
                },
                importEmployeesErrorModal : {
                    show: false
                }
            };
            //Used to show the move modal
            $scope.showModals = function(modal){
                $scope.disableNext = false;
                $scope.saved = false;
                $scope.uploadScreen = false;
                $scope.reset();
                TemplateLoader.load(modal).then(function(){
                    $scope.modals[modal].show = true;
                });
            };
            
            $scope.hideConfirmationModal = function(){
                $rootScope.$broadcast('refreshListPage', "refresh");
                $scope.hideModals();
            };
            
            //Used to hide all the modals on the page
            $scope.hideModals = function(){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key].show = false;
                });
            };

            $scope.templates = TemplateLoader.register({
                importEmployee: '/admin/config/users/importEmployees.html',
                importEmployeeConfirmation: '/admin/config/users/importEmployeesConfirmation.html',
                importEmployeesErrorModal: '/admin/config/users/importEmployeesErrorModal.html'
            });

            var removeLoadingState = function(){
                $scope.flags.loading = false;
            };
            
            
            $scope.import = function(){
               var response = {
                    'sendInviteEmail': $scope.checkbox.sendInviteEmail,
                    'uploadedFile': $scope.files.uploadedFile,
                    'fullSync': $scope.checkbox.fullSync,
                    'resetSync': $scope.checkbox.resetSync,
                    'considerExclusionList': $scope.checkbox.considerExclusionList,
                    'fileDelimiter': $scope.setting.delimiterSelected.id==="1"?'\\t':','
               };
               if($scope.files.uploadedFile && $scope.files.uploadedFile.employeeSyncKey && $scope.files.uploadedFile.fileName && $scope.importModal) {
                   if($scope.importModal === "employee") {
                       $rootScope.$broadcast('importedEmployeeSyncFile', response);
                   } else if($scope.importModal === "datasync") {
                       $rootScope.$broadcast('importedEmployeeDataSyncFile', response);
                   }
                   $scope.hideModals();
               } else {
                   $scope.fileError = true;
               }
            };
            
			$scope.$on('ImportFileUploadComplete', function(e, content, field) {
				$scope.fileError = !content;
				$scope.$apply(() => { $scope.fileError = !content; });
			});
            
            $scope.getColumnsMapping = function() {
                var response = {
                    'sendInviteEmail': $scope.checkbox.sendInviteEmail,
                    'uploadedFile': $scope.files.uploadedFile,
                    'fullSync': $scope.checkbox.fullSync,
                    'resetSync': $scope.checkbox.resetSync,
                    'considerExclusionList':$scope.checkbox.considerExclusionList,
                    'fileDelimiter': $scope.setting.delimiterSelected.id==="1"?'\\t':','
                };
                if($scope.files.uploadedFile && $scope.files.uploadedFile.employeeSyncKey && $scope.files.uploadedFile.fileName && $scope.importModal) {
                    $scope.disableNext = true;
                    if($scope.importModal === "employee") {
                        $rootScope.$broadcast('getSelects2Values', response);
                    } else if($scope.importModal === "datasync") {
                        $rootScope.$broadcast('getSelects2MappingValues', response);
                    }
                } else {
                    $scope.fileError = true;
                }
            };

            $scope.getColumnsMappingProcessing = function(section) {
                for(var entry in section) {
                    section[entry].selected  = section[entry].sync;
                    if(section[entry].toAttribute && section[entry].toAttribute.trim() !== "") {
                    	if(section[entry].fieldId ===-33 && $scope.checkbox.fullSync){
                    		//skipped for TransactionType
                    	} else{
                    		 section[entry].toAttribute = $scope.getPreSelectedValue(section[entry].toAttribute);
                    	}
                    }
                    if(section[entry].fieldId===-33 && $scope.checkbox.fullSync){
                    	section[entry].required  = true;
                    	section[entry].selected  = false;
                    }
                }
                return section;
            };

            $scope.getColumnsMappingResponse = function(response) {
                $scope.requiredUnmappedCount = 0;
                $scope.unmappedCount = 0;
                $scope.response = angular.copy(response);

                $scope.fieldSections = [
                    {
                        key: 'personal',
                        title: i18n.ADMIN_PERSONAL,
                        data: $scope.getColumnsMappingProcessing(response.personal)
                    },
                    {
                        key: 'jobInformation',
                        title: i18n.ADMIN_JOB_INFORMATION,
                        data: $scope.getColumnsMappingProcessing(response.jobInformation),
                    },
                    {
                        key: 'contactInformation',
                        title: i18n.ADMIN_CONTACT_INFORMATION,
                        data: $scope.getColumnsMappingProcessing(response.contactInformation)
                    },
                    {
                        key: 'organizationInformation',
                        title: i18n.ADMIN_ORGANIZATION_INFORMATION,
                        data: $scope.getColumnsMappingProcessing(response.organizationInformation)
                    },
                    {
                        key: 'regionInformation',
                        title: i18n.ADMIN_REGION_INFORMATION,
                        data: $scope.getColumnsMappingProcessing(response.regionInformation)
                    }
                ];
                if(response.hasCustomFields) {
                    $scope.fieldSections.push({
                        key: 'customInformation',
                        title: i18n.ADMIN_CUSTOM_INFORMATION,
                        data: $scope.getColumnsMappingProcessing(response.customInformation)
                    });
                }
                $scope.uploadScreen=!$scope.uploadScreen;
            };
            
            var _getColumnsMappingResponse = $rootScope.$on('getColumnsMappingResponse', function(event, response) {
                $scope.getColumnsMappingResponse(response);
            });

            var getMappingResponse = $rootScope.$on('getMappingResponse', function(event, response) {
                $scope.getColumnsMappingResponse(response);
            });
            
            $scope.validate = function(section) {
                for(var entries in section) {
                    if((section[entries].fieldId !== -33 && !$scope.checkbox.fullSync) && (section[entries].required || section[entries].selected) && (section[entries].toAttribute && section[entries].toAttribute.text.trim()) === "") {
                        $scope.jvError = true;
                        $scope.validationsPassed = false;
                        section[entries].showError = true;
                        section[entries].iconColor = "orange";
                        section[entries].notes = "Unmapped";
                        if(section[entries].required) {
                            section[entries].iconColor = "red";
                            section[entries].notes = "Required for import";
                        }
                    } else {
                        section[entries].showError = false;
                    }
                }
                return section;
            };

            //method to prepare post payload by adding/removing toAttribute for synce/not synced field
            $scope.beforeSave = function(updatedFields, actualFields) {
                for(var fieldTitle in updatedFields) {
                    actualFields[fieldTitle].sync = updatedFields[fieldTitle].selected;
                    if(updatedFields[fieldTitle] && updatedFields[fieldTitle].toAttribute){
                        if(updatedFields[fieldTitle].toAttribute.id && actualFields[fieldTitle]){
                            actualFields[fieldTitle].toAttribute = updatedFields[fieldTitle].toAttribute.id;
                        } else{
                            if(actualFields[fieldTitle] && actualFields[fieldTitle].toAttribute){
                                actualFields[fieldTitle].toAttribute = '';
                            }
                        }
                    }
                }
            };
           
            $scope.saveMapping = function() {
                $scope.validationsPassed = true;
                for(var section in $scope.fieldSections){
                    $scope.validate($scope.fieldSections[section].data);
                }
                if($scope.validationsPassed) {
                    $scope.jvError = false;
                    for(var counter in $scope.fieldSections){
                        var sectionItem = $scope.fieldSections[counter];
                        $scope.beforeSave(sectionItem.data, $scope.response[sectionItem.key]);
                    }
                    var response = {
                        'mapping': $scope.response,
                        'sendInviteEmail': $scope.checkbox.sendInviteEmail,
                        'uploadedFile': $scope.files.uploadedFile,
                        'fullSync': $scope.checkbox.fullSync,
                        'resetSync': $scope.checkbox.resetSync,
                        'considerExclusionList': $scope.checkbox.considerExclusionList,
                        'fileDelimiter': $scope.setting.delimiterSelected.id==="1"?'\\t':','
                    };
                    $scope.saved = true;
                    if($scope.importModal === "employee") {
                        $rootScope.$broadcast('submitMapping', response);
                    } else if($scope.importModal === "datasync") {
                        $rootScope.$broadcast('submit', response);
                    }
                    $scope.hideModals();
                }
            };
            
            $scope.getPreSelectedValue = function(value){
                var selectedVal = null;
                if($scope.standardJobCategoryNames && $scope.standardJobCategoryNames.length > 0) {
                    angular.forEach($scope.standardJobCategoryNames, function(standardJobCategoryNames){
                       if(standardJobCategoryNames.id === value) {
                           selectedVal = standardJobCategoryNames;
                       }
                    });
                    return selectedVal;
                }
            };
            $scope.getSelects2MappingValuesResponse = function (response) {
                $scope.standardJobCategoryNames = [];
                var employeeSampleDataArray;
                if(response && response.EmployeeSampleData) {
                    employeeSampleDataArray = JSON.parse(response.EmployeeSampleData);
                }

                if(employeeSampleDataArray && employeeSampleDataArray.length > 0) {
                    for(var i=0; i < employeeSampleDataArray.length ; i++) {
                        var employeeSampleDataObject = employeeSampleDataArray[i];
                        var keysInEmployeeSampleDataObject = Object.keys(employeeSampleDataObject);
                        if(keysInEmployeeSampleDataObject && keysInEmployeeSampleDataObject.length > 0) {
                            // Getting the first key from the array of keys (always with length 1) for the employeeSampleDataObject
                            const key = keysInEmployeeSampleDataObject[0];
                            $scope.standardJobCategoryNames.push({id:key, text: key, value:employeeSampleDataObject[key]});
                        }
                    }
                }
                if($scope.importModal === "employee") {
                    $rootScope.$broadcast('getMapping', response);
                } else if($scope.importModal === "datasync") {
                    $rootScope.$broadcast('getColumnsMapping', {});
                }
            };
            
            var _getSelects2MappingValuesResponse = $rootScope.$on('getSelects2MappingValuesResponse', function(event, response) {
                $scope.getSelects2MappingValuesResponse(response);
            });
            
            var getSelects2ValuesResponse = $rootScope.$on('getSelects2ValuesResponse', function(event, response) {
                $scope.getSelects2MappingValuesResponse(response);
            });
            
            $scope.checkEntries = function (section) {
                 for(var entries in section) {
                    // TODO: remove fieldId check when timezone fieldmapping is supported
                    if(!section[entries].required && section[entries].fieldId !== -31) {
                        section[entries].selected = $scope.selectedAll;
                    }
                 }
                return section;
            };
            
            $scope.checkAll = function () {
                $scope.requiredCount = 0;
                $scope.count = 0;
                $scope.selectedAll = angular.copy($scope.checkbox.selectAll);
                for(var section in $scope.fieldSections){
                    $scope.checkEntries($scope.fieldSections[section].data);
                }
                $scope.showWarnings();
            };

            $scope.unselectEntries = function (section) {
                for(var entries in section) {
                    if((!section[entries].required && section[entries].selected) && (section[entries].toAttribute && section[entries].toAttribute.text.trim()) === "") {
                        section[entries].selected  = false;
                    }
                }
            return section;
           };

            $scope.unselect = function () {
                $scope.requiredCount = 0;
                $scope.count = 0;
                $scope.checkbox.selectAll = false;
                for(var section in $scope.fieldSections){
                    $scope.unselectEntries($scope.fieldSections[section].data);
                }
                $scope.showWarnings();
                
            };

            $scope.$on('$destroy', function() {
                showImportEmployeeModal();
                showImportEmployeeConfirmationModal();
                showImportEmployeeConfirmation();
                getMappingResponse();
                getSelects2ValuesResponse();
                _getSelects2MappingValuesResponse();
                _getColumnsMappingResponse();
            });
            $scope.updateResetFlag=function(){
         	   if(!$scope.checkbox.fullSync){
         		   $scope.checkbox.resetSync=false;
                   $scope.checkbox.considerExclusionList=false;
                   $scope.fullSyncFlagAlert = false;
         	   } else{
                   $scope.checkbox.considerExclusionList=true;
                   $scope.fullSyncFlagAlert = true;
         	   }
            }
            
        }
]);